module.exports = __webpack_public_path__ + "static/media/ihsm_logo.493fe274.png";